var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMasterCard = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 46,
  height: 32,
  fill: "none",
  viewBox: "0 0 46 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M.5 4A3.5 3.5 0 0 1 4 .5h38A3.5 3.5 0 0 1 45.5 4v24a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 28z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ED0006",
  fillRule: "evenodd",
  d: "M22.905 22.44a9.07 9.07 0 0 1-5.864 2.133c-4.993 0-9.041-4-9.041-8.933 0-4.934 4.048-8.933 9.04-8.933a9.07 9.07 0 0 1 5.865 2.134 9.07 9.07 0 0 1 5.865-2.134c4.993 0 9.04 4 9.04 8.933 0 4.934-4.047 8.933-9.04 8.933a9.07 9.07 0 0 1-5.865-2.134",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F9A000",
  fillRule: "evenodd",
  d: "M22.905 22.44a8.87 8.87 0 0 0 3.177-6.8 8.87 8.87 0 0 0-3.177-6.8 9.07 9.07 0 0 1 5.865-2.133c4.993 0 9.04 4 9.04 8.933 0 4.934-4.047 8.933-9.04 8.933a9.07 9.07 0 0 1-5.865-2.134",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF5E00",
  fillRule: "evenodd",
  d: "M22.905 22.44a8.87 8.87 0 0 0 3.176-6.8 8.87 8.87 0 0 0-3.176-6.8 8.87 8.87 0 0 0-3.177 6.8 8.87 8.87 0 0 0 3.177 6.8",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMasterCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/masterCard.67721a6628181f6c193b6d93cd39186c.svg";